export const supportedLanguages = ['en', 'de'];
export const defaultLanguage = 'en';
